import { useState, SetStateAction } from 'react';

type ForceUpdate = () => SetStateAction<void>;

export const useForceUpdate = (): ForceUpdate => {
    const [value, setValue] = useState(0);
    return () => setValue(value + 1);
};
